var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPermits)?_c('div',[(_vm.$route.name !== 'user-with-permit' && _vm.$route.name !== 'add-user-with-permit')?_c('PermitsSidebar',{attrs:{"selectedTenant":_vm.selectedTenant}}):_vm._e(),_vm._v(" "),(_vm.$route.name === 'user-with-permit' || _vm.$route.name === 'add-user-with-permit')?_c('AddEditPermitView',{ref:"permit",attrs:{"selectedTenant":_vm.selectedTenant}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56831b62","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/Permits.vue
// module id = 1465
// module chunks = 65